import React from "react";

import AppContext, { AppContextState } from "./AppContext";

// Wraps around App to be able to pull global state anywhere in tree via useContext
const useAppContext = (): AppContextState => React.useContext(AppContext);

export default useAppContext;
